/* eslint-disable */
export default {
  eula: 'Contrato de Licença do Utilizador Final',
  eulaAbbr: 'EULA',
} as const;

// @key: @#@"eula"@#@ @source: @#@"End User License Agreement"@#@
// @key: @#@"eulaAbbr"@#@ @source: @#@"EULA"@#@
